import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { motion } from "framer-motion";
import { useAuth } from "../lib/auth";
import { toast } from "sonner";

const LOGO = "https://customer-assets.emergentagent.com/job_db817c75-ae59-4832-b768-836f101e64ef/artifacts/g0jqvbfq_PHOTO-2022-03-31-12-08-17-1.jpg";
const BG = "https://images.unsplash.com/photo-1764458988314-5ce35e94bf63?crop=entropy&cs=srgb&fm=jpg&w=1600&q=85";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("admin@karrkraft.com");
  const [password, setPassword] = useState("KarrKraft@123");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = await login(email, password);
      toast.success("Welcome back.");
      if (u?.user_type === "customer" || u?.role === "customer") {
        nav("/portal/home");
      } else {
        nav("/dashboard");
      }
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-[var(--kk-bg)]">
      {/* Visual */}
      <div className="hidden lg:block relative overflow-hidden">
        <img src={BG} alt="" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-tr from-black/70 via-black/30 to-transparent" />
        <div className="absolute inset-0 p-12 flex flex-col justify-between text-white">
          <div className="flex items-center gap-4">
            <img src={LOGO} className="w-24 h-24 object-contain bg-white p-2" alt="" />
            <div>
              <div className="font-display text-3xl leading-none">KARR KRAFT</div>
              <div className="kk-overline text-white/70 text-[0.7rem] mt-1">High End Service · Sales</div>
            </div>
          </div>
          <div>
            <motion.h2
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
              className="font-display text-5xl xl:text-7xl uppercase leading-none"
            >
              The Workshop <br /> Command Centre.
            </motion.h2>
            <p className="mt-6 text-white/80 max-w-md text-sm">
              A single, uncompromising console for servicing, sales, stores and accounts
              — built for garages that refuse to be ordinary.
            </p>
            <div className="mt-8 flex gap-4 kk-overline text-white/60 text-[0.6rem]">
              <span>01 · SHOWROOM</span>
              <span>02 · SERVICE</span>
              <span>03 · STORES</span>
              <span>04 · ACCOUNTS</span>
            </div>
          </div>
        </div>
      </div>

      {/* Form */}
      <div className="flex items-center justify-center p-6 md:p-12">
        <motion.form
          onSubmit={submit}
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          className="w-full max-w-sm"
        >
          <div className="flex lg:hidden items-center gap-3 mb-8">
            <img src={LOGO} className="w-16 h-16 object-contain" alt="" />
            <div className="font-display text-2xl">KARR KRAFT</div>
          </div>
          <div className="kk-overline mb-2">Access</div>
          <h1 className="font-display text-4xl uppercase leading-none">Sign In</h1>
          <p className="text-[var(--kk-muted)] text-sm mt-2">
            Use your Karr Kraft credentials. Admin seed is auto-provisioned.
          </p>

          <div className="mt-8 space-y-6">
            <div>
              <span className="kk-label">Email</span>
              <input
                className="kk-input"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                data-testid="login-email"
                required
              />
            </div>
            <div>
              <span className="kk-label">Password</span>
              <input
                className="kk-input"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                data-testid="login-password"
                required
              />
            </div>
          </div>

          <button
            type="submit"
            disabled={loading}
            className="kk-btn-primary w-full mt-8 justify-center"
            data-testid="login-submit"
          >
            {loading ? "Signing in…" : "Enter Command Centre →"}
          </button>

          <div className="mt-6 text-xs text-[var(--kk-muted)]">
            New user?{" "}
            <Link to="/register" className="text-[var(--kk-black)] font-semibold underline" data-testid="goto-register">
              Create an account
            </Link>
          </div>
          <div className="mt-2 text-[0.7rem] font-mono text-[var(--kk-muted)]">
            Seeded admin · admin@karrkraft.com / KarrKraft@123
          </div>
          <Link to="/portal" className="block mt-6 pt-5 border-t border-[var(--kk-border)] text-xs font-semibold text-[var(--kk-black)] underline" data-testid="goto-portal">
            Customer? Go to your portal →
          </Link>
        </motion.form>
      </div>
    </div>
  );
}
